export const EMPTY_TRACKING = Object.freeze({ enabled: false, ga4_id: "", google_ads_id: "", google_ads_label: "", meta_pixel_id: "", tiktok_pixel_id: "" });
export const TRACKING_FIELDS = [
    { key: "ga4_id", label: "Google Analytics 4 — ID misurazione", pattern: "G-[A-Za-z0-9]+", example: "G-…", limit: 64 },
    { key: "google_ads_id", label: "Google Ads — ID conversione", pattern: "AW-[0-9]+", example: "AW-…", limit: 32 },
    { key: "google_ads_label", label: "Google Ads — etichetta conversione", pattern: "[A-Za-z0-9_-]+", example: "Etichetta della conversione Lead", limit: 128 },
    { key: "meta_pixel_id", label: "Meta — ID Pixel", pattern: "[0-9]+", example: "Solo cifre", limit: 32 },
    { key: "tiktok_pixel_id", label: "TikTok — codice Pixel web", pattern: "[A-Za-z0-9]+", example: "Codice da Events Manager", limit: 128 },
];
export const validTracking = (raw = {}) => {
    const out = { ...EMPTY_TRACKING, enabled: raw.enabled === true };
    TRACKING_FIELDS.forEach(({ key, pattern, limit }) => {
        const value = typeof raw[key] === "string" ? raw[key].trim() : "";
        out[key] = value.length <= limit && new RegExp(`^${pattern}$`).test(value) ? value : "";
    });
    return out;
};
export const configKey = (raw) => {
    const t = validTracking(raw);
    return JSON.stringify(t.enabled ? t : { enabled: false });
};
export const configuredVendors = (raw) => {
    const t = validTracking(raw);
    return [
        { name: "Google Analytics 4", category: "Statistiche", configured: t.enabled && !!t.ga4_id, cookies: "_ga, _ga_*", duration: "Fino a 2 anni" },
        { name: "Google Ads", category: "Marketing", configured: t.enabled && !!t.google_ads_id && !!t.google_ads_label, cookies: "_gcl_*; eventuali cookie Google di terze parti", duration: "_gcl_*: normalmente 90 giorni; altri secondo le impostazioni del fornitore" },
        { name: "Meta Pixel", category: "Marketing", configured: t.enabled && !!t.meta_pixel_id, cookies: "_fbp, _fbc", duration: "Normalmente 90 giorni" },
        { name: "TikTok Pixel", category: "Marketing", configured: t.enabled && !!t.tiktok_pixel_id, cookies: "_ttp, ttcsid, ttcsid_*", duration: "Fino a 13 mesi, secondo le impostazioni del fornitore" },
    ];
};